// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout_wrapper__2dOTA"};